import React from 'react';
import { DataList, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';
import Filter from '../selectFilter';

const ScheduledDowntimeList: React.FC<{}> = () => {
	const { forceUpdate, showLoader, setShowLoader, jumpBack, jumpNext, pageNumber, getAllDowntimeData, handleFormSubmit } =
		useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, { setShowLoader });
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<Filter handleFormSubmit={handleFormSubmit} />
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					gap: '20px'
				})}>
				<div title='nav' className={css({ padding: '6px 6px' })}>
					{pageNumber.currPage > 0 && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpBack();
							}}>
							← Prev Page
						</Button>
					)}
					{pageNumber.nextPage !== null && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpNext();
							}}>
							Next Page →
						</Button>
					)}
				</div>
			</div>
			<DataList
				fetchData={getAllDowntimeData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.SCHEDULED_DOWNTIME}
				filterable={false}
				searchable={false}
				globalForceUpdate={forceUpdate}
			/>
		</>
	);
};

export default ScheduledDowntimeList;
